import { render } from "./ModalDialogEx.vue?vue&type=template&id=a2a2cbdc&scoped=true"
import script from "./ModalDialogEx.vue?vue&type=script&lang=js"
export * from "./ModalDialogEx.vue?vue&type=script&lang=js"

import "./ModalDialogEx.vue?vue&type=style&index=0&id=a2a2cbdc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a2cbdc"]])

export default __exports__